import { Link } from "react-router-dom";

import { ReactComponent as TrainingIcon } from "@/assets/img/menu/trainings-icon.svg";
import { ReactComponent as TrainerIcon } from "@/assets/img/menu/trainer-icon.svg";
import { ReactComponent as SettingsIcon } from "@/assets/img/menu/settings-icon.svg";

import styles from "./Menu.module.scss";
import { tg } from "@/constants/telegram";

type MenuProps = {
  active?: number;
};

export const Menu: React.FC<MenuProps> = ({ active }) => {
  const menuItems = [
    { title: "Тренировки", icon: <TrainingIcon />, to: "/trains" },
    {
      title: "Тренер",
      icon: <TrainerIcon />,
      to: "/ai-chat",
    },
    { title: "Настройки", icon: <SettingsIcon />, to: "/more" },
  ];

  const handleLinkClick = (e: React.MouseEvent) => {
    tg.HapticFeedback.impactOccurred("medium");
  };

  return (
    <div className={styles.root}>
      <div className="container">
        {menuItems.map((item, key) => {
          const className = `${styles.root__item} ${active === key ? "active" : ""}`;
          return (
            <Link
              key={key}
              to={item.to!}
              className={className}
              onClick={handleLinkClick}
            >
              {item.icon}
              <span>{item.title}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

